import { push } from 'react-router-redux';
import Cookies from 'js-cookie';

import forceLogoutHandler from '../users/a.users.forceLogoutHandler';

import {

} from '../actions.export'

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// Get components by organization
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestGetComponentsByOrganization = packet => {
  return {
    type: 'REQUEST_GET_COMPONENTS_BY_ORGANIZATION',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveGetComponentsByOrganizationSuccess = data => ({
  type: 'RECEIVE_GET_COMPONENTS_BY_ORGANIZATION_SUCCESS',
  data
})

export const receiveGetComponentsByOrganizationFail = data => ({
  type: 'RECEIVE_GET_COMPONENTS_BY_ORGANIZATION_FAIL',
  data
})

export const tryToGetComponentsByOrganization = packet => (dispatch, getState) => {

  dispatch(requestGetComponentsByOrganization(packet));

  let headers = {
    "Content-Type": "application/json"
  }
  


  let fs = localStorage.getItem(process.env.REACT_APP_COOKIE_FEATURE_SWITCH);
  if(fs){
    headers["X-NFS"] = fs;
  }


  headers["X-CSRF-TOKEN"] = getState().userReducer.csrf_token;

  let url = '/api/components/org/' + packet.org_id;

  if(packet.startAfter){
    url += '?startAfter=' + packet.startAfter;
  }

  return fetch(url, {
      method: 'get',
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(receiveGetComponentsByOrganizationSuccess(json));
    })
    .catch(e => {
      dispatch(forceLogoutHandler(e));
      dispatch(receiveGetComponentsByOrganizationFail({errors:e, lastSubmit: packet}));
    })
}
